import { render, staticRenderFns } from "./ImportPortfolioDetails.vue?vue&type=template&id=917f608e&scoped=true&"
import script from "./ImportPortfolioDetails.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImportPortfolioDetails.vue?vue&type=style&index=0&id=917f608e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917f608e",
  null
  
)

export default component.exports